var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics"},[_c('img',{attrs:{"src":_vm.icon}}),_c('div',{staticClass:"statistics-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"statistics-value",style:({color: _vm.types}),domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }